import adaptEmployeesForBagInclusion from "../../../infrastructure/adapters/adaptEmployeesForBagInclusion";
import { addEmployeesToModelThatHasBag } from "../../../infrastructure/repository/benefit-models-repository";

export default async function addEmployeesToExistantModelWithBag({
  company,
  benefitPlan,
  amount,
  date,
  employees,
}) {
  await addEmployeesToModelThatHasBag(
    adaptEmployeesForBagInclusion({
      company,
      benefitPlan,
      amount,
      date,
      employees,
    })
  );
}
